







































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import { date } from '@/util/adapter';
const getUrl = require('bmh/url-with-param');
const uuidv4 = require('uuid/v4');
const dateFormat = require('bmh/date-format');
const numeral = require('numeral');
const { VUE_APP_FCAPI: FCAPI } = process.env;

interface Form {
  award_type: number;
  bonus_time: Moment[];
}

const API = {
  desc: `${FCAPI}/shang/promotion/activity`,
  query: `${FCAPI}/shang/promotion/activity/bonus`,
};
const AWARD_TYPE_LIST: any[] = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '浏览奖励',
  },
  {
    value: 2,
    label: '报名奖励',
  },
];
@Component
export default class ActivityConfig extends Vue {
  activity: any = {};
  activity_id: any = '';
  award_data: any = {
    data: [],
  };
  form: Form = {
    award_type: 0,
    bonus_time: [],
  };
  is_loading: boolean = false;
  now_timestamp: number = 0;
  page: number = 1;
  schedule_data: any = {};
  award_type_list: any = AWARD_TYPE_LIST;
  send_data: any = {};

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  // 导出数据
  exportData() {
    this.getSendData();
    this.send_data.is_export = 1;
    const params = this.send_data;
    let url = '';
    url = `${API.query}?`;
    for (const key in params) {
      if (key && params[key]) {
        url += `&${key}=${params[key]}`;
      }
    }
    window.location.href = url;
  }

  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  async getDescribe() {
    this.is_loading = true;
    const _data =
      ((await this.$axios.get(`${API.desc}/${this.activity_id}`)) || {}).data ||
      {};
    this.is_loading = false;
    if (_data.error) {
      console.debug(_data.message);
      return;
    }
    this.award_data.data = [_data.data];
    this.activity = _data.data;
    this.now_timestamp = ~~(+new Date() / 1000);
    if (this.now_timestamp < this.activity.start_time) {
      this.activity.activity_status = '未开始';
    } else {
      if (this.now_timestamp < this.activity.end_time) {
        this.activity.activity_status = '进行中';
      } else {
        this.activity.activity_status = '已结束';
      }
    }
  }

  getSendData() {
    const send_data: any = {
      activity_id: this.activity_id,
      type: this.form.award_type,
      start_time: this.form.bonus_time[0]
        ? this.form.bonus_time[0].format('X')
        : '',
      end_time: this.form.bonus_time[1]
        ? this.form.bonus_time[1].format('X') + 86400
        : '',
    };
    this.send_data = send_data;
  }

  async query(page: number = 1) {
    this.getSendData();
    this.send_data.current = page;
    this.send_data.limit = 5;
    const res = await this.$axios.get(API.query, {
      params: this.send_data,
    });
    if (res.data.status !== 200) {
      this.schedule_data = [];
      console.debug(res.data.message);
      return;
    }
    this.schedule_data = res.data.data;
  }

  submit() {
    this.query();
  }
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  async created() {
    if (this.$route.query.activity_id) {
      this.activity_id = this.$route.query.activity_id;
    }
    await this.getDescribe();
    await this.query();
  }
}
